<template>
  <b-container fluid>
    <b-row class='my-2'>
      <b-col cols=11>
        <b-form-select :options=selectOptions v-model=option @change=runQuery />
      </b-col>
      <b-col>
        <b-btn :href=csvPath :disabled="busy || option == null">Get CSV</b-btn>
      </b-col>
    </b-row>
    <b-row class='my-2'>
      <b-col>
        <center class='my-4' v-if=busy>
          <fingerprint-spinner :animation-duration="1500" :size="300" color="#293a93" class="my-3" />
        </center>
        <b-form-input v-if="result.length > 1" v-model="filter" placeholder="Type to Filter" />
        <b-table :fields="columns" :items="result" :busy="busy" :filter="filter" :sort-compare-options="{ numeric: true }" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from 'axios';
import { FingerprintSpinner } from 'epic-spinners';

export default {
  data() {
    return {
      queries: [],
      option: null,
      busy: false,
      columns: [],
      result: [],
      filter: '',
    }
  },
  mounted() {
    this.getQueries();
  },
  components: {
    FingerprintSpinner,
  },
  computed: {
    csvPath() {
      return `${this.$api}/fishbowl/data-module/data.csv?id=${this.option}`
    },
    selectOptions() {
      return [ { value: null, text: 'Select a Query' } ].concat(this.queries.map((query) => {
        return { value: query['id'], text: `${query['name']}${query['description'] == '' ? '' : `: ${query['description']}` }` }
      }));
    },
  },
  methods: {
    getQueries() {
      axios.get(`${this.$api}/fishbowl/data-module/list`).then(response => {
        this.queries = response.data
      }).catch((error) => {
        console.error(error);
      })
    },
    runQuery() {
      this.busy = true;
      this.result = [];
      axios.get(`${this.$api}/fishbowl/data-module/${this.option}`).then(response => {
        this.result = response.data;
        this.columns = Object.keys(this.result[0]).map(key => (
          { key, sortable: true }
        ));
      }).catch((error) => {
        console.error(error)
      }).finally(() => {
        this.busy = false;
      });
    },
  },
}
</script>

<style scoped>
.table thead th {
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/FishbowlData.vue